
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.178 9.804c0 .217-.123.326-.37.326h-.131v-.596h.139c.241 0 .362.09.362.27zM1 22h2.312l1.146 2 2.401-3.724a11.51 11.51 0 01-3.204-2.379L1 22zm17.526-4.339l-2.213-.304-.84 2.04-1.977-1.031L12 20l-1.497-1.634-1.977 1.031-.84-2.04-2.213.304-.079-2.2L3.208 15l.687-2.095L2 11.737 3.374 10 2 8.263l1.895-1.168L3.208 5l2.187-.46.079-2.2 2.213.304.84-2.04 1.977 1.031L12 0l1.497 1.634L15.474.603l.84 2.04 2.213-.304.079 2.2L20.792 5l-.687 2.095L22 8.263 20.626 10 22 11.737l-1.895 1.168.687 2.095-2.187.46-.079 2.201zM19 10a7 7 0 10-14 0 7 7 0 0014 0zm1.345 7.897a11.51 11.51 0 01-3.204 2.379L19.542 24l1.146-2H23l-2.655-4.103zM18 10c0 3.309-2.691 6-6 6s-6-2.691-6-6 2.691-6 6-6 6 2.691 6 6zM9.542 9H8v2.61h.695v-.98h.781v-.565h-.781v-.5h.847V9zm2.666 2.61l-.761-1.137c.295-.166.443-.399.443-.702.001-.514-.356-.771-1.064-.771h-.855v2.61h.706v-.95h.178l.554.95h.799zM13.995 9h-1.55v2.61h1.55v-.575h-.845v-.493h.781v-.565h-.781v-.412h.845V9zM16 9h-1.55v2.61H16v-.575h-.844v-.493h.781v-.565h-.781v-.412H16V9z"}})])
          )
        }
      }
    